import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "forwardArrow",
  "use": "forwardArrow-usage",
  "viewBox": "0 0 8 13",
  "content": "<symbol viewBox=\"0 0 8 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"forwardArrow\">\n<path d=\"M2.25 12.5C2.5625 12.5 2.90625 12.375 3.15625 12.125L7.65625 7.375C8.09375 6.90625 8.09375 6.125 7.65625 5.65625L3.15625 0.90625C2.65625 0.40625 1.875 0.375 1.375 0.875C0.875 1.34375 0.84375 2.125 1.3125 2.625L5 6.53125L1.3125 10.4062C0.84375 10.9062 0.875 11.6875 1.375 12.1875C1.625 12.4062 1.9375 12.5 2.25 12.5Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/forwardArrow.svg
// module id = khzi
// module chunks = 13